// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 945) return "js/template/dashboard.js";
	if (chunkId === 404) return "js/template/usuarios.js";
	if (chunkId === 98) return "js/template/concursos.js";
	if (chunkId === 941) return "js/template/proyectos.js";
	if (chunkId === 267) return "js/template/categorias.js";
	if (chunkId === 663) return "js/template/jurados.js";
	if (chunkId === 574) return "js/template/pre-home.js";
	if (chunkId === 28) return "js/template/novedades.js";
	if (chunkId === 634) return "js/template/terminos.js";
	if (chunkId === 555) return "js/template/politicas.js";
	if (chunkId === 234) return "js/template/dudas.js";
	if (chunkId === 812) return "js/template/t&c.js";
	if (chunkId === 733) return "js/template/historial-usuario.js";
	if (chunkId === 420) return "js/template/errores-formulario.js";
	if (chunkId === 969) return "js/template/tratamiento-datos.js";
	if (chunkId === 129) return "js/template/datos-personales-terceros.js";
	// return url for filenames based on template
	return undefined;
};